import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '@services/toast/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ComponentBase } from '../../../abstracts/component-base';
import { SupportMessage } from '../../../dto/supportMesagge';
import { User } from '../../../models/identity/user';
import { UsersService } from '../../../services/entity/users.service';
import { FormService } from '../../../services/form/form.service';
import { DatasecurityComponent } from '../../authentication/datasecurity/datasecurity.component';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent extends ComponentBase implements OnInit {

  public className = 'SupportComponent';
  public user: User;
  public formCreated: boolean;

  constructor(
    public formService: FormService,
    private spinner: NgxSpinnerService,
    private usersService: UsersService,
    private dialog: NgbModal,
    private toastService: ToastService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    this.formService.validators = {
      subject: [Validators.required],
      message: [Validators.required],
      contactMe: [],
    }

    this.formService.form = new UntypedFormGroup({
      subject: new UntypedFormControl('', this.formService.validators['subject']),
      message: new UntypedFormControl('', this.formService.validators['message']),
      contactMe: new UntypedFormControl(false, this.formService.validators['contactMe']),
    });
    
    this.formService.formMap = new Map<string, UntypedFormGroup>();
    this.formCreated = true;
  }
  
  openDSDialog() {
    const dialogRef = this.dialog.open(DatasecurityComponent, { centered: true, size: 'lg', backdrop: 'static' });

    dialogRef.result.then((result) => {
      this.ngOnInit();
    }, (backdrop) => {

    });
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@ChangeDialogSendedSuccessHeader:Ihre Anfrage wurde versendet!`,
      text: $localize`:@@ChangeDialogSendedSuccessText:Vielen Dank.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.ngOnInit();
    });
  }

  public sendMessageToSupport(supportMessageFormValue) {
    this.spinner.show();

    const formValues = { ...supportMessageFormValue };

    const supportMessage: SupportMessage = {
      subject: formValues.subject,
      message: formValues.message,
      contactMe: true
    };

    this.usersService.sendMessageToSupport(supportMessage).subscribe(result => {
      this.createForm();
      this.toastService.success($localize`:@@ChangeDialogSendedSuccessHeader:Ihre Anfrage wurde versendet!`);
      this.spinner.hide();
    },
    error => {        
      this.spinner.hide();
    })
  }
}
